import { useRef, useState } from "react";
import OfferRewardListMain from "./offer-reward-list-main";
import OfferRewardFreeEdit from "./freeproduct/offer-reward-free-edit";
import OfferRewardDiscountEdit from "./discount/offer-reward-discount-edit";
import OfferRewardVoucherEdit from "./voucher/offer-reward-voucher-edit";

const OfferRewardMain = (props) => {
  const listRef = useRef(null);

  const [visibleEditorFreeDialog, setVisibleEditorFreeDialog] = useState(false);
  const [visibleEditorDiscountDialog, setVisibleEditorDiscountDialog] = useState(false);
  const [visibleEditorVoucherDialog, setVisibleEditorVoucherDialog] = useState(false);
  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  // handle ui event section

  const handleOnClickRowEditFree = (row) => {
    setEditorData(row);
    setVisibleEditorFreeDialog(true);
  };

  const handleOnClickRowEditDiscount = (row) => {
    setEditorData(row);
    setVisibleEditorDiscountDialog(true);
  };

  const handleOnClickRowEditVoucher = (row) => {
    setEditorData(row);
    setVisibleEditorVoucherDialog(true);
  };

  const handleOnClickRowDelete = (row) => {
    if (row.id && row.id > 0) {
      setEditorData(row);
      setVisibleDeleteDialog(true);
    }
  };

  const handleOnClickAddNew = () => {
    setEditorData({});
    setVisibleEditorFreeDialog(true);
  };

  const handleOnConfirmedEditFree = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorFreeDialog(false);
  };

  const handleOnConfirmedEditDiscount = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorDiscountDialog(false);
  };

  const handleOnConfirmedEditVoucher = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorVoucherDialog(false);
  };

  const handleOnConfirmedDelete = (data) => {
    listRef.current.handleOnDeleteViewRow(data);
    setVisibleDeleteDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <OfferRewardFreeEdit
        visible={visibleEditorFreeDialog}
        onHide={() => setVisibleEditorFreeDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEditFree}
      />

      <OfferRewardDiscountEdit
        visible={visibleEditorDiscountDialog}
        onHide={() => setVisibleEditorDiscountDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEditDiscount}
      />

      <OfferRewardVoucherEdit
        visible={visibleEditorVoucherDialog}
        onHide={() => setVisibleEditorVoucherDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEditVoucher}
      />

      <OfferRewardListMain
        ref={listRef}
        onClickRowEditFree={handleOnClickRowEditFree}
        onClickRowEditDiscount={handleOnClickRowEditDiscount}
        onClickRowEditVoucher={handleOnClickRowEditVoucher}
      />
    </div>
  );
};

export default OfferRewardMain;
